"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore file */
var models_1 = require("../..");
var Errors_1 = require("../../../../helpers/Errors");
var PrimitiveTypes_1 = require("./");
var SnapshotHelper_1 = require("../../../../helpers/SnapshotHelper");
var LightingType = /** @class */ (function (_super) {
    __extends(LightingType, _super);
    function LightingType() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PrimitiveTypes_1.Lighting;
        return _this;
    }
    LightingType.prototype.getLightStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var point, value, mappedValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.findPointByName(this.pointNames.lightToggle)];
                    case 1:
                        point = _a.sent();
                        if (point === null)
                            throw new Errors_1.EntityNotFoundError("Toggle point missing on Light. Unable to retrieve light status.");
                        return [4 /*yield*/, point.getValue()];
                    case 2:
                        value = _a.sent();
                        if (value === undefined)
                            throw new Errors_1.InternalServerError("Toggle point missing value. Unable to retrieve light status.");
                        mappedValue = point.mapValue(value);
                        if ("".concat(mappedValue).toLowerCase() == "on")
                            return [2 /*return*/, "on"];
                        return [2 /*return*/, "off"];
                }
            });
        });
    };
    LightingType.prototype.getLightActivityForPeriod = function (from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var point, snapshots, mappedSnapshots, ms, hourly, percent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.findPointByName(this.pointNames.lightToggle)];
                    case 1:
                        point = _a.sent();
                        if (point === null)
                            throw new Errors_1.EntityNotFoundError("Relay point missing on Shelly. Unable to retrieve light activity.");
                        return [4 /*yield*/, point.getValueSnapshots(from, to)];
                    case 2:
                        snapshots = _a.sent();
                        mappedSnapshots = snapshots.map(function (_a) {
                            var snapshot = _a.snapshot, value = _a.value;
                            return ({
                                snapshot: +new Date(snapshot),
                                value: point.mapValue(value)
                            });
                        });
                        ms = (0, SnapshotHelper_1.getMsAtValueFromSnapshots)(mappedSnapshots, "on", from, to);
                        hourly = (0, SnapshotHelper_1.getHourlyMsAtValueFromSnapshots)(mappedSnapshots, "on", from, to);
                        percent = ms / (+to - +from);
                        return [2 /*return*/, {
                                ms: ms,
                                hourly: hourly,
                                percent: percent
                            }];
                }
            });
        });
    };
    return LightingType;
}(models_1.Equipment));
exports.default = LightingType;
